import { z } from 'zod';
const identifier = z.string().trim().min(1).max(128);
export const startCallSchema = z
    .object({
    chatId: identifier,
    kind: z.enum(['audio', 'video']),
    waitingRoom: z.boolean().optional()
})
    .strict();
export const callTargetSchema = z.object({ callId: identifier }).strict();
export const callStateUpdateSchema = z
    .object({
    isMuted: z.boolean().optional(),
    isCameraOn: z.boolean().optional(),
    isScreenSharing: z.boolean().optional(),
    handRaised: z.boolean().optional()
})
    .strict()
    .refine((value) => Object.keys(value).length > 0, 'Нужно изменить состояние');
export const callLinkJoinSchema = z.object({ token: z.string().min(32).max(256) }).strict();
export const callPushActionSchema = z
    .object({
    action: z.enum(['accept', 'decline']),
    token: z.string().trim().min(32).max(2048)
})
    .strict();
export const callParticipantManageSchema = z
    .object({
    role: z.enum(['speaker', 'listener']).optional(),
    admit: z.boolean().optional()
})
    .strict()
    .refine((value) => value.role !== undefined || value.admit !== undefined, 'Нет изменений');
export const callHistoryDeleteSchema = z.discriminatedUnion('scope', [
    z
        .object({
        scope: z.literal('selected'),
        callIds: z
            .array(identifier)
            .min(1)
            .max(100)
            .refine((ids) => new Set(ids).size === ids.length, 'Звонки не должны повторяться')
    })
        .strict(),
    z.object({ scope: z.literal('all') }).strict()
]);
//# sourceMappingURL=calls.js.map